
export default {
    props: {
        city: Object,
        metrics: Array,
        services: Object
    }
}
